import React, { useEffect } from 'react'
import Dashboardmy from '../Dashboard-component/Dashboard'
import Wishlist from '../wishlist/Wish'
import { useNavigate } from 'react-router-dom';
import './wish.css';
import { useSelector } from 'react-redux';
function Wishlistdash() {
    const navigate = useNavigate();
    const login = useSelector((state) => state.auth?.auth?.access_token);
    useEffect(() => {
        if (!login) {
            navigate("/login");
        }
    }, [login, navigate]);
    return (
        <>
            
                <div className='wish-content'>

                    <Dashboardmy />
                    <div className='wishlist-container'>
                        <Wishlist />
                    </div>
                </div>
      

        </>
    )
}

export default Wishlistdash;